module.exports = __webpack_public_path__ + "img/jordanelle.9641b02c.png";